import { NgModule } from '@angular/core';

import { TooltipDirective } from './directives';

@NgModule({
    declarations: [
        TooltipDirective,
    ],
    exports: [
        TooltipDirective,
    ],
})

export class TooltipModule {}
